import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "@learningblocks/shared-components/lib/FormattedMessage";

import className from "../style.module.scss";

export function ImageEntity(props) {
  const ariaLive = props.data.props.ariaLive;
  const shouldAnnounce = ariaLive && ariaLive !== "none";

  const viewAltText =
    props.viewAltText && props.viewAltText !== ""
      ? FormattedMessage({
          string: props.viewAltText,
        })
      : "";

  const imageAltText =
    props.data.props.altText !== ""
      ? FormattedMessage({
          string: props.data.props.altText,
        })
      : "";

  const altText = viewAltText || imageAltText;

  return (
    <div
      className={className.entityContainer}
      style={{
        overflow: !props.allowOverflow ? "hidden" : null,
      }}
      role={shouldAnnounce ? "status" : "presentation"}
      {...(shouldAnnounce && { "aria-live": ariaLive })}
    >
      <div className={className.imageEntityContainer} role="presentation">
        <img
          alt={altText}
          src={props.preview ? props.data.props.url : props.src.src}
        />
      </div>
    </div>
  );
}

ImageEntity.propTypes = {
  data: PropTypes.shape({
    props: PropTypes.shape({
      src: PropTypes.string.isRequired,
      altText: PropTypes.string,
      ariaLive: PropTypes.oneOf(["none", "polite", "assertive"]),
    }).isRequired,
  }).isRequired,
  allowOverflow: PropTypes.bool.isRequired,
  preview: PropTypes.bool,
  src: PropTypes.object,
  viewAltText: PropTypes.string,
};
